import { memo } from "react";
import { Typography } from "@/components";
import { formatTokenAmountForDisplay } from "@/utils";

interface RedemptionQueueHeaderProps {
    totalQueued: string;
    totalFunded: string;
}

export const RedemptionQueueHeader = memo(function RedemptionQueueHeader({
    totalQueued,
    totalFunded,
}: RedemptionQueueHeaderProps) {
    const queuedTotal = Number(totalQueued);
    const fundedTotal = Number(totalFunded);
    // const fullyFundedText = queueInfo?.fullyFundedTimestampMs
    //     ? queueInfo.fullyFundedTimestampMs > Date.now()
    //         ? getTimeRemaining(new Date(queueInfo.fullyFundedTimestampMs).toISOString(), true)
    //         : "Available now"
    //     : "Unavailable";

    return (
        <div className="space-y-4">
            <div className="flex flex-wrap items-center justify-between gap-4">
                <div className="space-y-1">
                    <h2 className="text-primary text-[24px] leading-[28px] font-medium">Redemption Queue</h2>
                </div>

                <div className="flex flex-wrap gap-3">
                    <div className="rounded-lg border border-primary/20 bg-card px-3 py-2">
                        <Typography variant="body2" className="text-dark/70">
                            Ready to claim
                        </Typography>
                        <span className="inline-flex items-center gap-1 text-sm font-medium text-primary">
                            <span>{formatTokenAmountForDisplay(fundedTotal)}</span>
                            <span>USDC</span>
                        </span>
                    </div>
                    <div className="rounded-lg border border-primary/20 bg-card px-3 py-2">
                        <Typography variant="body2" className="text-dark/70">
                            Total queued
                        </Typography>
                        <span className="inline-flex items-center gap-1 text-sm font-medium text-primary">
                            <span>{formatTokenAmountForDisplay(queuedTotal)}</span>
                            <span>iUSD</span>
                        </span>
                    </div>
                </div>
            </div>

            {/* {queueInfo && (
                <Box card className="gap-4 p-4">
                    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
                        <QueueMetric label="Total positions">{queueInfo.totalPositions.toLocaleString()}</QueueMetric>
                        <QueueMetric label="Total in queue">
                            <TokenAmount
                                amount={formatTokenAmountForDisplay(queueInfo.totalAmountNormalized)}
                                tokenId={TOKEN_IDS.IUSD}
                                size="sm"
                            />
                        </QueueMetric>
                        <QueueMetric label="Available liquidity">
                            <TokenAmount
                                amount={formatTokenAmountForDisplay(queueInfo.liquidityAvailableNormalized)}
                                tokenId={TOKEN_IDS.USDC}
                                size="sm"
                            />
                        </QueueMetric>
                        <QueueMetric label="Estimated fully funded">{fullyFundedText}</QueueMetric>
                    </div>
                </Box>
            )} */}
        </div>
    );
});

RedemptionQueueHeader.displayName = "RedemptionQueueHeader";
